<template>
    <button class="border border-gray-light rounded overflow-hidden w-full h-full hover:border-secondary cursor-pointer" :class="{'border-secondary': is_selected}" :data-tippy-content="content.name" ref="el">
        <label :for="spec.id+content.value" class="block w-full h-full aspect-square cursor-pointer" :style="'color' in content && !content?.color ? `background:${content?.color}` : default_color"></label>
    </button>
</template>

<script>

export default {
    name: "color",
    props: ['spec', 'content', 'selected_specs'],
    data: () => ({
        default_color: 'background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red);',
    }),
    computed: {
        is_selected: ctx => ctx.selected_specs && ctx.selected_specs[ctx.spec.id] && ctx.selected_specs[ctx.spec.id].values && ctx.selected_specs[this.spec.id].values.indexOf(ctx.content.value) > -1
    },
    mounted() {

    }
}
</script>
